// Sole import gate for all mock JSON. Per AGENT_RULES Rule 1.5: when the real API
// arrives, only this file changes — every component continues to call the same
// async-shaped getters. Each getter returns a Promise resolving to the `data` field
// of the AGENT_RULES envelope, mirroring how the backend will respond.

import users from '../../../mock-data/users.json';
import hubs from '../../../mock-data/hubs.json';
import hubConnections from '../../../mock-data/hub_connections.json';
import stickies from '../../../mock-data/stickies.json';
import niche from '../../../mock-data/niche.json';
import goldenThreads from '../../../mock-data/golden_threads.json';
import hiddenGems from '../../../mock-data/hidden_gems.json';
import surveyStats from '../../../mock-data/survey_stats.json';
import cvRoles from '../../../mock-data/cv_roles.json';
import roadmapThemes from '../../../mock-data/roadmap_themes.json';
import buyerJourney from '../../../mock-data/buyer_journey.json';
import contentPillars from '../../../mock-data/content_pillars.json';
import contentIdeas from '../../../mock-data/content_ideas.json';
import clients from '../../../mock-data/clients.json';
import seasons from '../../../mock-data/seasons.json';
import valueMetrics from '../../../mock-data/value_metrics.json';
import qualityBar from '../../../mock-data/quality_bar.json';
import outcomes from '../../../mock-data/outcomes.json';
import addedValue from '../../../mock-data/added_value.json';
import coachThreads from '../../../mock-data/coach_threads.json';
import surveyDefaults from '../../../mock-data/survey_defaults.json';
import pipelineOpportunities from '../../../mock-data/pipeline_opportunities.json';
import pipelineArticles from '../../../mock-data/pipeline_articles.json';
import pipelineContacts from '../../../mock-data/pipeline_contacts.json';
import pipelineNurture from '../../../mock-data/pipeline_nurture.json';
import targetAudience from '../../../mock-data/target_audience.json';
import acquisitionStrategy from '../../../mock-data/acquisition_strategy.json';
import mqlDefinition from '../../../mock-data/mql_definition.json';
import researchFramework from '../../../mock-data/research_framework.json';
import qualificationGate from '../../../mock-data/qualification_gate.json';
import discoveryScript from '../../../mock-data/discovery_script.json';
import proposalEmail from '../../../mock-data/proposal_email.json';
import roadmapDeck from '../../../mock-data/roadmap_deck.json';
import commercialTerms from '../../../mock-data/commercial_terms.json';

// Single-record getter helper (where envelope `data` is an object, not an array).
const ok = (value) => Promise.resolve(value);

export const getUser = () => ok(users.data[0]);
export const getHubs = () => ok(hubs.data);
export const getHubConnections = () => ok(hubConnections.data);
export const getStickies = () => ok(stickies.data);
export const getNiche = () => ok(niche.data);
export const getGoldenThreads = () => ok(goldenThreads.data);
export const getHiddenGems = () => ok(hiddenGems.data);
export const getSurveyStats = () => ok(surveyStats.data);
export const getCvRoles = () => ok(cvRoles.data);
export const getRoadmapThemes = () => ok(roadmapThemes.data);
export const getBuyerJourney = () => ok(buyerJourney.data);
export const getContentPillars = () => ok(contentPillars.data);
export const getContentIdeas = () => ok(contentIdeas.data);
export const getClients = () => ok(clients.data);
export const getSeasons = () => ok(seasons.data);
export const getValueMetrics = () => ok(valueMetrics.data);
export const getQualityBar = () => ok(qualityBar.data);
export const getOutcomes = () => ok(outcomes.data);
export const getAddedValue = () => ok(addedValue.data);

// Coach thread is filtered server-side by context_slug; we replicate the filter here.
// Falls back to the 'hub' (canvas overview) thread when the slug has no messages.
export const getSurveyDefaults = () => ok(surveyDefaults.data);

export const getOpportunities = () => ok(pipelineOpportunities.data);
export const getArticlesTracker = () => ok(pipelineArticles.data);
export const getActiveContacts = () => ok(pipelineContacts.data);
export const getNurtureContacts = () => ok(pipelineNurture.data);
export const getTargetAudience = () => ok(targetAudience.data);
export const getAcquisitionStrategy = () => ok(acquisitionStrategy.data);
export const getMqlDefinition = () => ok(mqlDefinition.data);
export const getResearchFramework = () => ok(researchFramework.data);
export const getQualificationGate = () => ok(qualificationGate.data);
export const getDiscoveryScript = () => ok(discoveryScript.data);
export const getProposalEmail = () => ok(proposalEmail.data);
export const getRoadmapDeck = () => ok(roadmapDeck.data);
export const getCommercialTerms = () => ok(commercialTerms.data);

export const getCoachThread = (contextSlug) => {
  const all = coachThreads.data;
  const matched = all.filter((m) => m.context_slug === contextSlug);
  if (matched.length > 0) return ok(matched);
  return ok(all.filter((m) => m.context_slug === 'hub'));
};
